import { trace } from 'owa-trace';
import FolderStore from '../store/schema/FolderStore';
import { addFolderInSortedOrderUnderParentFolder } from '../actions/localFolderOperations';
import getFullFolderId from '../util/getFullFolderId';
import getFolderTable from '../selectors/getFolderTable';
import { mutator } from 'satcheljs';
import { createNewFolderInStore } from '../actions/publicActions';
import BaseFolderType from 'owa-service/lib/contract/BaseFolderType';
import { mapOWSFolderToGql } from 'owa-folder-gql-mappers';

mutator(createNewFolderInStore, actionMessage => {
    addFolderToStore(
        actionMessage.folderStore,
        actionMessage.folder,
        actionMessage.parentFolderId,
        actionMessage.displayName
    );
});

function addFolderToStore(
    folderStore: FolderStore,
    item: BaseFolderType,
    parentFolderId: string,
    displayName: string
) {
    const fullParentFolderId = getFullFolderId(parentFolderId);

    // Get the parent folder tree type here. This will also become the treetype of the folder currently being added.
    const parentFolder = getFolderTable().get(parentFolderId);
    if (!parentFolder) {
        trace.warn('addFolderToStore: parent folder was not found');
    }

    const folder = {
        ...mapOWSFolderToGql(item, parentFolder.mailboxInfo),
        ...{
            DisplayName: displayName,
        },
    };

    folderStore.folderTable.set(item.FolderId.Id, folder);
    addFolderInSortedOrderUnderParentFolder(folder, folderStore, fullParentFolderId.Id);
}
